import type { App } from '@grafikr/components';
import type { ProductMedia } from '@grafikr/shopify-typescript/type/liquid/ProductMedia';
import { fromEvent } from 'rxjs';
import { render as renderSolidJS } from 'solid-js/web';

import Content from 'components/reactive/header/search/content';

import FullModal from 'utils/components/full-modal';

export default (node: HTMLElement, CLASSES: { HEADER_OVERLAY_ACTIVE: string }, app: App) => {
  const trigger = node.querySelector('[data-search-trigger]');
  const container = node.querySelector('[data-target="search"]');
  const blocks: { cta: string; url: string; image: ProductMedia }[] = JSON.parse(
    node.querySelector('[data-blocks]').textContent,
  );

  renderSolidJS(
    () => <Content app={app} blocks={blocks} />,
    container.querySelector('[data-search-content]'),
  );

  const initOpenable = () => {
    const navigation = new FullModal(container.querySelector('[data-search]'), {
      overlay: {
        index: 20,
      },
    });

    fromEvent(trigger, 'click').subscribe(() => {
      navigation.toggle();
    });

    fromEvent(navigation.root.querySelectorAll('[data-close]'), 'click').subscribe(() => {
      navigation.close();
    });

    navigation.on('open', () => {
      node.setAttribute('data-overlay-element', 'search');
      node.classList.add(CLASSES.HEADER_OVERLAY_ACTIVE);
      document.body.style.overflow = 'hidden';
    });

    navigation.on('opened', () => {
      navigation.root.querySelector<HTMLInputElement>('input[name="q"]')?.focus();
    });

    navigation.on('close', () => {
      node.removeAttribute('data-overlay-element');
      node.classList.remove(CLASSES.HEADER_OVERLAY_ACTIVE);
      document.body.style.overflow = null;
    });
  };

  initOpenable();
};
